var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-template',{attrs:{"backHidden":"","toolbar":_vm.toolbar}},[(_vm.tenant.account_status === 'trialing')?_c('trialing-home-dashboard'):_c('active-home-dashboard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }